var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('circle',{attrs:{"opacity":"0.08","cx":"16","cy":"16","r":"16","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"16","cy":"16","r":"4","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }